/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_IdInputs */



/**
* | output |
* | --- |
* | "Project ID" |
*
* @param {Project_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_id = /** @type {((inputs?: Project_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do projeto")
	return /** @type {LocalizedString} */ ("Project ID")
});